import { render } from "./ResponsiveSubheader.vue?vue&type=template&id=45a613f6&scoped=true"
import script from "./ResponsiveSubheader.vue?vue&type=script&lang=js"
export * from "./ResponsiveSubheader.vue?vue&type=script&lang=js"

import "./ResponsiveSubheader.vue?vue&type=style&index=0&id=45a613f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a613f6"]])

export default __exports__